<template>
  <div>
    <div :key="item.id" v-for="(item, index) in contextAdvances">
      <v-row dense class="flex-nowrap">
        <v-col cols="3">
          <amount-input :readonly="readonly" :error-messages="amountInCurrencyValidation(item, index)" :model.sync="item.amount_in_currency" />
        </v-col>
        <v-col cols="3">
          <currency-select :readonly="readonly" :model.sync="item.currency" :validation-message="currencyValidation(item, index)" />
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            :error-messages="paymentTypeValidation(item, index)"
            :items="payment_types"
            :clearable="!readonly"
            item-text="name"
            item-value="id"
            :label="$t('components.advance.fields.paymentType.name')"
            v-model="item.payment_type"
            :readonly="readonly"
          />
        </v-col>
        <v-col cols="3">
          <date-picker
            :date-validation="paymentDateValidation(item, index)"
            :model.sync="item.payment_date"
            :label="$t('components.advance.fields.paymentDate.name')"
            :max="maxDate"
            :readonly="readonly"
          >
          </date-picker>
        </v-col>
        <v-icon v-if="clearable & !readonly" v-on:click="removeAdvance(item)">close</v-icon>
      </v-row>
      <v-row v-if="isExtendedAdvancesEnabled">
        <v-col cols="8">
          <v-text-field :label="$t('global.comment')" v-model="item.comment" :readonly="readonly" />
        </v-col>
        <v-col cols="4">
          <ajax-file :items="item.files" :readonly="readonly" />
        </v-col>
      </v-row>
      <v-divider v-if="index < contextAdvances.length - 1" class="mb-4" />
    </div>
  </div>
</template>

<script>
import CurrencySelect from "../CustomInputComponents/CurrencySelect.vue";
import DatePicker from "../CustomInputComponents/DatePicker.vue";
import PaymentTypes from "../../staticData/PaymentTypes";
import AmountInput from "../CustomInputComponents/AmountInput.vue";
import AjaxFile from "../CustomInputComponents/AjaxFile";

export default {
  name: "SimpleAdvanceList",
  data: () => ({}),
  props: {
    readonly: {
      required: false,
      default: false
    },
    modelAdvances: {
      required: true
    },
    clearable: {
      required: false,
      default: false
    },
    validationModel: {
      required: false,
      default: null
    },
    maxDate: {
      required: false,
      default: null
    }
  },
  components: { AjaxFile, AmountInput, DatePicker, CurrencySelect },
  methods: {
    removeAdvance(item) {
      this.$emit("removeAdvanceItem", item);
    },
    amountInCurrencyValidation(item, index) {
      if (this.validationModel != null && typeof this.validationModel[index] !== "undefined") {
        return this.validationModel[index].amount_in_currency;
      }
      if (item.amount_in_currency == null || item.amount_in_currency.length < 1) {
        return [this.$t("global.error.required")];
      }
      return [];
    },
    currencyValidation(item, index) {
      if (this.validationModel != null && typeof this.validationModel[index] !== "undefined") {
        return this.validationModel[index].currency;
      }
      if (item.currency == null || item.currency.length < 1) {
        return [this.$t("global.error.required")];
      }
      return [];
    },
    paymentTypeValidation(item, index) {
      if (this.validationModel != null && typeof this.validationModel[index] !== "undefined") {
        return this.validationModel[index].payment_type;
      }
      return [];
    },
    paymentDateValidation(item, index) {
      if (this.validationModel != null && typeof this.validationModel[index] !== "undefined") {
        return this.validationModel[index].payment_date;
      }
      return [];
    }
  },
  computed: {
    isExtendedAdvancesEnabled() {
      let userProperty = this.$store.getters["userProperties"];
      return userProperty.system_settings.delegation_advance_flow === 2;
    },
    payment_types: PaymentTypes,
    contextAdvances: {
      set(value) {
        this.$emit("update:modelAdvances", value);
      },
      get() {
        return this.modelAdvances;
      }
    }
  }
};
</script>

<style scoped></style>
